module.exports = __webpack_public_path__ + "media/images/requisitions/pc_head-63235fb8aaafb9435697720649c42584.png";